import { REDUCER_DEVICE_GET_DATA, REDUCER_DEVICE_CLEAR } from "../../../../../constants/reducers/widget-page-action-events";
import { REDUCER_SET_META_DATA, REDUCER_CHECKPOINT } from '../../../../../constants/reducers/get-meta-data'
import adjustPages from '../../../../../helpers/merge-page-info'

const DEFAULT_STATE = {}

export default (state = DEFAULT_STATE, action) => {
  const {type} = action

  switch (type) {
    case REDUCER_DEVICE_GET_DATA:
      return action.payload;
    case REDUCER_DEVICE_CLEAR:
      return DEFAULT_STATE;
    case REDUCER_CHECKPOINT:
      return 'payload' in action &&
              action.payload &&
              'checkpoint' in action.payload &&
              action.payload.checkpoint &&
              'Device' in action.payload.checkpoint &&
              action.payload.checkpoint.Device ?
                action.payload.checkpoint.Device
              :
                DEFAULT_STATE
    case REDUCER_SET_META_DATA:
      return 'payload' in action &&
              action.payload &&
              'device' in action.payload &&
              action.payload.device ?
                adjustPages(action.payload.device.pages, action.payload.device.filters, action.payload.device.decorators)
              :
                DEFAULT_STATE
    default:
      return state;
  }
}
